import React, { Component } from 'react';

import MyAccountNavigation from './MyAccountNavigation';

import { localeStrings as strings } from 'applicationConfig';

import './myAccount.scss';

const MENU_ITEMS = [
  { href: '/my-account/details', text: strings.myAccount.userDetails },
  { href: '/my-account/subscriptions', text: strings.myAccount.subscriptions },
  { href: '/my-account/change-password', text: strings.myAccount.changePassword }
];

const myAccountHOC = function(WrappedComponent) {
  return class MyAccount extends Component {
    render() {
      return (
        <div className="my-account-wrapper">
          <MyAccountNavigation menuItems={MENU_ITEMS} />

          <WrappedComponent {...this.props} />
        </div>
      );
    }
  };
};

export { myAccountHOC };



// WEBPACK FOOTER //
// ./src/containers/MyAccount/MyAccount.jsx